module.exports = __webpack_public_path__ + "img/ctrl-u-stub-up--i.e5eb5b70.svg";